// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PilotMultiChoiceOptionContainer$LiteracyplanetTupperware from "./PilotMultiChoiceOptionContainer.res.mjs";

function PilotRadioButtonMultiChoice(props) {
  return React.createElement(PilotMultiChoiceOptionContainer$LiteracyplanetTupperware.make, {
              group: "SingleResponse",
              questionIndex: props.questionIndex,
              responseOptionId: props.responseOptionId,
              children: props.children
            });
}

var make = PilotRadioButtonMultiChoice;

export {
  make ,
}
/* react Not a pure module */
